import { render, staticRenderFns } from "./CaseStudies.vue?vue&type=template&id=40b0b80e&scoped=true"
import script from "./CaseStudies.vue?vue&type=script&lang=js"
export * from "./CaseStudies.vue?vue&type=script&lang=js"
import style0 from "./CaseStudies.vue?vue&type=style&index=0&id=40b0b80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b0b80e",
  null
  
)

export default component.exports